
import Vue from 'vue';
import Component from 'vue-class-component';
import TButton from '@/lib/form/button/Button.vue';
import TInput from '@/lib/form/input/Input.vue';
import apiClient from '@/app/clients/api-client';
import { debounce } from '@/lib/utils/functions';

@Component({
  name: 't-search',
  props: ['hideLabel'],
  components: {
    TButton,
    TInput
  }
})
export default class TrainnSearch extends Vue {
  private search = '';
  private loading = false;
  private resultSet: any[] = [];
  debouncer: any;

  constructor() {
    super();
    this.debouncer = debounce();
  }

  searchFn() {
    if (!this.search) {
      this.$root.$emit('search-empty');
      this.$root.$emit('no-search-result', false);

      return;
    }
    this.loading = true;
    this.debouncer(() => this.updateSearch(), 1000);
  }

  updateSearch() {
    apiClient
      .searchVideos(this.search)
      .then(data => {
        this.loading = false;
        this.resultSet = data;
        if (this.$isEmpty(data) && this.search) {
          this.$root.$emit('no-search-result', true);
          return;
        }
        this.$root.$emit('search-videos-results', data);
        this.$root.$emit('no-search-result', false);
      })
      .catch(error => {
        this.loading = false;
        this.$error(error);
      });
  }
}
